import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG } from '../app-config.token';
import { AppConfig } from '../app-config';
import { NotificationDto, PagedNotificationResult } from '../models/dtos/notification-dto';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private http = inject(HttpClient);
    private config = inject<AppConfig>(APP_CONFIG);

    private readonly API_URL = this.config.resourceApiURI + '/notifications';

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() { }

    getNotificationsPaged(skip: number, count: number): Observable<PagedNotificationResult> {
        const params = new HttpParams()
            .set('skip', skip)
            .set('count', count);

        return this.http.get<PagedNotificationResult>(this.API_URL, { params }).pipe(
            map(res => <PagedNotificationResult>{
                ...res,
                Results: res.Results?.map((a) => <NotificationDto>{
                    ...a,
                    Date: a.Date && new Date(a.Date + 'Z')
                })
            })
        );
    }

    setAsRead(id: number): Observable<void> {
        const url = `${this.API_URL}/${id}/setAsRead`

        return this.http.patch<void>(url, null);
    }
}
